import { compose, withState, withHandlers } from 'coact/recompose'

const stockScannerContainer = compose(
  withState('isScannerOpen', 'setIsScannerOpen', false),

  withHandlers({
    openScanner:
      ({ setIsScannerOpen }) =>
      () => {
        setIsScannerOpen(true)
      },
    closeScanner:
      ({ setIsScannerOpen }) =>
      () => {
        setIsScannerOpen(false)
      },
    onScanResult: () => code => {
      alert(code)
    },
  }),
)

export default stockScannerContainer
